(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function setupComparison(guide) {
    var buttons = guide.querySelectorAll('[data-amp-svs-filter]');
    var rows = guide.querySelectorAll('[data-amp-svs-row]');
    var insight = guide.querySelector('[data-amp-svs-insight]');

    function selectRow(row) {
      var feature = row.cells && row.cells[0] ? row.cells[0].textContent : 'Buyer note';
      var detail = row.getAttribute('data-amp-svs-detail') || '';

      for (var i = 0; i < rows.length; i += 1) {
        rows[i].classList.remove('amp-svs-is-selected');
      }

      row.classList.add('amp-svs-is-selected');

      if (insight) {
        insight.innerHTML = '<strong>' + escapeHtml(feature) + '</strong><span>' + escapeHtml(detail) + '</span>';
      }
    }

    function applyFilter(value) {
      var firstVisible = null;

      for (var i = 0; i < buttons.length; i += 1) {
        var active = buttons[i].getAttribute('data-amp-svs-filter') === value;
        buttons[i].classList.toggle('amp-svs-is-active', active);
        buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      for (var j = 0; j < rows.length; j += 1) {
        var row = rows[j];
        var category = row.getAttribute('data-amp-svs-category');
        var visible = value === 'all' || category === value;
        row.hidden = !visible;
        row.classList.remove('amp-svs-is-selected');

        if (visible && !firstVisible) {
          firstVisible = row;
        }
      }

      if (firstVisible) {
        selectRow(firstVisible);
      }
    }

    for (var i = 0; i < buttons.length; i += 1) {
      buttons[i].addEventListener('click', function () {
        applyFilter(this.getAttribute('data-amp-svs-filter') || 'all');
      });
    }

    for (var j = 0; j < rows.length; j += 1) {
      rows[j].addEventListener('click', function () {
        selectRow(this);
      });

      rows[j].addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectRow(this);
        }
      });
    }

    if (rows.length) {
      selectRow(rows[0]);
    }
  }

  function setupFaq(guide) {
    var items = guide.querySelectorAll('[data-amp-svs-faq-item]');

    for (var i = 0; i < items.length; i += 1) {
      items[i].addEventListener('toggle', function () {
        if (!this.open) {
          return;
        }

        for (var j = 0; j < items.length; j += 1) {
          if (items[j] !== this) {
            items[j].open = false;
          }
        }
      });
    }
  }

  function setupReveal(guide) {
    var revealItems = guide.querySelectorAll('[data-amp-svs-reveal]');
    guide.classList.add('amp-svs-has-js');

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < revealItems.length; i += 1) {
        revealItems[i].classList.add('amp-svs-is-visible');
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('amp-svs-is-visible');
          observer.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    for (var j = 0; j < revealItems.length; j += 1) {
      observer.observe(revealItems[j]);
    }
  }

  function setupNav(guide) {
    var links = guide.querySelectorAll('.amp-svs-nav a[href^="#"]');

    if (!links.length || !('IntersectionObserver' in window)) {
      return;
    }

    var sections = [];
    for (var i = 0; i < links.length; i += 1) {
      var id = links[i].getAttribute('href');
      var section = id ? guide.querySelector(id) : null;
      if (section) {
        sections.push(section);
      }
    }

    function setActive(id) {
      for (var j = 0; j < links.length; j += 1) {
        links[j].classList.toggle('amp-svs-is-active', links[j].getAttribute('href') === '#' + id);
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k += 1) {
        if (entries[k].isIntersecting) {
          setActive(entries[k].target.id);
        }
      }
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0.01 });

    for (var l = 0; l < sections.length; l += 1) {
      observer.observe(sections[l]);
    }
  }

  function initGuide(guide) {
    if (!guide || guide.getAttribute('data-amp-svs-ready') === 'true') {
      return;
    }

    guide.setAttribute('data-amp-svs-ready', 'true');
    setupComparison(guide);
    setupFaq(guide);
    setupReveal(guide);
    setupNav(guide);
  }

  function initAll(context) {
    var root = context || document;
    var guides = root.querySelectorAll('[data-amp-svs-guide]');

    for (var i = 0; i < guides.length; i += 1) {
      initGuide(guides[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
